export type Navigation = {
  title: string;
  linkList?: LinkList[];
  link?: string;
};

export type LinkList = {
  link: string;
  href?: string;
  linkText?: string;
  target?: string;
  managerOnly?: boolean;
};

import {
  filterSectionsByAllowedLabels,
  getAllowedLabelsForPrimaryRole,
} from "../utils/roleVisibility";

export const headerNavigations: Navigation[] = [
  {
    title: "Find a UBT",
    linkList: [
      {
        linkText: "Find and Select a UBT",
        link: "/home/select-ubt",
      },
      {
        linkText: "Search UBTs Projects",
        link: "/home/search-teams",
      },
      {
        linkText: "Teams Reporting",
        link: "/home/teams-reporting",
      },
    ],
  },
  {
    title: "Teams",
    linkList: [
      {
        linkText: "My Teams",
        link: "/home/my-teams",
      },
      {
        linkText: "Create New UBT",
        link: "/home/add-profile",
      },
      {
        linkText: "Edit UBT",
        link: "/home/edit-ubt",
      },
      {
        linkText: "Manage Access",
        link: "/home/manage-access",
      },
    ],
  },
  {
    title: "Path-to-performance",
    link: "/home/path-to-performance",
  },
  {
    title: "Contact us",
    link: "/home/contact-us",
  },
  {
    title: "Document Upload",
    link: "/home/team-documents",
  },
  {
    title: "UBT Home",
    link: "/home",
  },
];

const HEADER_ALLOWED_LINKS_BY_ROLE = {
  lmp: [
    "Find and Select a UBT",
    "Search UBTs Projects",
    "Teams Reporting",
    "My Teams",
    "Contact us",
    "Manage Access",
    "Path-to-performance",
    "Document Upload",
    "UBT Home",
  ],
  member: [
    "Find and Select a UBT",
    "Search UBTs Projects",
    "Teams Reporting",
    "My Teams",
    "Contact us",
    "Path-to-performance",
    "Document Upload",
    "UBT Home",
  ],
} as const;

/**
 * Returns the header navigation items filtered by the user's primary role.
 * - Administrator: full navigation list (unrestricted)
 * - LMP: subset of nav items for LMP users
 * - All other roles (Member, View-Only, Consultant, Coordinator, etc.): member-restricted nav items
 * @param primaryRole - The user's primaryRole from the profile slice.
 */
export function getFilteredHeaderNavigations(primaryRole: string): Navigation[] {
  const allowedLabels = getAllowedLabelsForPrimaryRole(
    primaryRole,
    HEADER_ALLOWED_LINKS_BY_ROLE,
  );

  if (!allowedLabels) {
    return headerNavigations;
  }

  return filterSectionsByAllowedLabels(headerNavigations, allowedLabels, {
    getItems: (navigation) => navigation.linkList,
    setItems: (navigation, linkList) => ({ ...navigation, linkList }),
    getItemLabel: (link) => link.linkText,
    getSectionLabel: (navigation) => navigation.title,
  });
}

export default headerNavigations;